import jQuery from "jquery";

const $ = jQuery;

const compareCardsTableFunction = (function($) { // eslint-disable-line
  if (document.querySelector('[data-compare-cards-sticky-element]')) {
    const compareCardsStickyElement = document.querySelector('[data-compare-cards-sticky-element]');
    const compareCardsTable = document.querySelector('[data-compare-cards-table]');
    const compareCardsTableHead = document.querySelector('[data-compare-cards-table-head]');
    const compareCardsPageHeader = document.querySelector('.page-header');
    let headerHeight = compareCardsPageHeader.offsetHeight;
    let hasMobileHeader = true;
    let tableScrollBreakpoint;
    let compareCardsResizeDebounceTimeOut;
    let compareCardsScrollDebounceTimeOut;

    function setHasMobileHeader() {
      headerHeight = compareCardsPageHeader.offsetHeight;
      hasMobileHeader = window.innerWidth < 769;
      compareCardsTable.style.marginTop = `-${compareCardsTableHead.offsetHeight}px`;
      compareCardsStickyElement.style.marginTop = `${compareCardsTableHead.offsetHeight - compareCardsStickyElement.offsetHeight}px`;
      compareCardsStickyElement.style.top = hasMobileHeader ? `${headerHeight}px` : 0;
    }
    setHasMobileHeader();

    window.addEventListener('resize', () => {
      clearTimeout(compareCardsResizeDebounceTimeOut);
      compareCardsResizeDebounceTimeOut = setTimeout(() => {
        setHasMobileHeader();
      }, 100);
    }, { passive: true });

    compareCardsTable.addEventListener('scroll', () => {
      compareCardsStickyElement.scrollLeft = compareCardsTable.scrollLeft;
    });

    function setCompareCardsStickytableHead() {
      const compareCardsTableHeadBottomBreakpoint = Math.ceil(compareCardsTableHead.getBoundingClientRect().bottom);
      tableScrollBreakpoint = window.scrollY + compareCardsTableHeadBottomBreakpoint - compareCardsStickyElement.offsetHeight - (hasMobileHeader ? headerHeight : 0);

      if (window.scrollY >= tableScrollBreakpoint) {
        compareCardsStickyElement.style.opacity = 1;
        compareCardsStickyElement.style.pointerEvents = "auto";
      } else {
        compareCardsStickyElement.style.opacity = 0;
        compareCardsStickyElement.style.pointerEvents = "none";
      }
    }

    window.addEventListener('scroll', () => {
      clearTimeout(compareCardsScrollDebounceTimeOut);
      compareCardsScrollDebounceTimeOut = setTimeout(() => {
        setCompareCardsStickytableHead();
      }, 100);
    }, { passive: true });
  }
})(jQuery); // eslint-disable-line

export default compareCardsTableFunction;
